import validator from 'validator';

export function CustomRelayValidator(value: string) {
  if (value === '')
    return {
      valid: true,
      error: '',
    };

  if (value && value.length > 256)
    return {
      valid: false,
      error: 'Maximum 256 characters allowed.',
    };

  const IPs = value.split(';');

  for (const ip of IPs) {
    if (!validator.isIP(ip) && !validator.isFQDN(ip, { require_tld: false })) {
      return {
        valid: false,
        error: 'Invalid name/IP {ip}',
        ip: ip,
      };
    }

    if (IPs.indexOf(ip) !== IPs.lastIndexOf(ip)) {
      return {
        valid: false,
        error: 'Duplicate name/IP {ip}',
        ip: ip,
      };
    }
  }

  return {
    valid: true,
    error: '',
  };
}
